import { CloseButton } from '@spazious/dollhouse-shared';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogHeader,
  DialogProps,
  Flex,
  Typography,
} from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';

import {
  ReservationForm,
  ReservationFormProvider,
  ReservationFormValues,
  useReservationForm,
} from '../ReservationForm/index.js';

export interface SetupFormDialogProps extends Omit<DialogProps, 'onClose'> {
  onSubmit: (formValues: ReservationFormValues) => void;
  onClose: (event: {}, reason: 'backdropClick' | 'escapeKeyDown' | 'btnCancelClick') => void;
}

export const ReservationFormDialog: React.FC<SetupFormDialogProps> = ({
  onSubmit,
  onClose,
  ...restProps
}) => {
  const methods = useReservationForm();

  const { isSubmitting, isDirty } = methods.formState;
  const { handleSubmit } = methods;

  const handleBtnCancel = useEventCallback(() => {
    onClose({}, 'btnCancelClick');
  });

  return (
    <ReservationFormProvider {...methods}>
      <Dialog {...restProps} onClose={onClose}>
        <DialogHeader>
          <Typography size="small" variant="headline">
            Request for proposal
          </Typography>
          <CloseButton onClick={handleBtnCancel} />
        </DialogHeader>
        <DialogContent>
          <ReservationForm onSubmit={onSubmit} />
        </DialogContent>
        <DialogActions>
          <Flex gap="var(--spacing-gap)" justifyContent="flex-end" width="100%">
            <Button
              color="primary"
              disabled={!isDirty || isSubmitting}
              onClick={handleSubmit(onSubmit)}
            >
              Send
            </Button>
          </Flex>
        </DialogActions>
      </Dialog>
    </ReservationFormProvider>
  );
};
